module.exports = __webpack_public_path__ + "static/media/file5.23b141f9.jpg";